import React from 'react'
import PropTypes from 'prop-types'
import OpalHeading from '../../../../opal/OpalHeading'
import FlexRow from '../../../../molecules/FlexRow'
import DatasourceLink from './DatasourceLink'

function DatasourceGroup ({ groupName, groupItems }) {
  return (
    <div>
      <OpalHeading className='font-size-md'>{groupName}</OpalHeading>
      <FlexRow className='gap-sm flex-wrap'>
        {(groupItems || []).map(item => (
          <DatasourceLink key={item.code} datasource={item} />
        ))}
      </FlexRow>
    </div>
  )
}

DatasourceGroup.propTypes = {
  groupName: PropTypes.string,
  groupItems: PropTypes.arrayOf(PropTypes.shape({
    catalogDatasourceId: PropTypes.number,
    code: PropTypes.string,
    displayName: PropTypes.string,
    imageUrl: PropTypes.string,
    isSystem: PropTypes.bool,
    isInternal: PropTypes.bool,
    isAiEnabled: PropTypes.bool,
    isAlwaysAvailable: PropTypes.bool,
    isDeprecated: PropTypes.bool,
    namespace: PropTypes.shape({
      displayName: PropTypes.string
    })
  }))
}

export default DatasourceGroup
